"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComparisonRowsFromItems = void 0;
var _key = require("b2b-components/utils/key");
const getHeadersRowsFromItem = (rowsConfig, item) => {
  return {
    header: [...rowsConfig.header, {
      id: (0, _key.createKey)(item.id, 'header'),
      content: item.header
    }],
    sticky: [...rowsConfig.sticky, ...(item.headerSticky ? [{
      id: (0, _key.createKey)(item.id, 'header-sticky'),
      content: item.headerSticky
    }] : [])]
  };
};
const getCommonSpecificationAttributes = (items, specificationIndex) => (attributes, attribute, attributeIndex) => {
  const commonAttributeValues = items.map(item => ({
    id: item.id,
    values: item.specification[specificationIndex]?.attributes[attributeIndex]?.values || []
  }));
  const values = commonAttributeValues.reduce((allValues, value) => [...allValues, value.values.join()], []);
  const hasDifferences = values.some((value, _, self) => value !== self[0]);
  return [...attributes, ...(values.filter(value => !!value).length ? [{
    ...attribute,
    values: commonAttributeValues,
    hasDifferences
  }] : [])];
};
const getCommonItemsSpecification = items => (specifications, specification, specificationIndex) => {
  const attributes = specification.attributes.reduce(getCommonSpecificationAttributes(items, specificationIndex), []);
  return [...specifications, ...(attributes.length ? [{
    ...specification,
    attributes
  }] : [])];
};
const getRowsFromAttribute = (isSingleItem, specificationName) => (attributesRows, attribute) => [...attributesRows, {
  label: attribute.name,
  id: (0, _key.createKey)('label', specificationName, attribute.name)
}, {
  id: (0, _key.createKey)(specificationName, attribute.name),
  cells: [...attribute.values.map(value => ({
    ...value,
    id: (0, _key.createKey)(specificationName, attribute.name, value.id)
  })), ...(isSingleItem ? [{
    id: (0, _key.createKey)('cell-empty', specificationName, attribute.name),
    values: []
  }] : [])],
  hasDifferences: attribute.hasDifferences
}];
const getRowsFromSpecification = isSingleItem => (rows, specification) => [...rows, ...(specification.name ? [{
  labelPrimary: specification.name,
  id: (0, _key.createKey)('label-primary', specification.name)
}] : []), ...specification.attributes.reduce(getRowsFromAttribute(isSingleItem, specification.name || ''), [])];
const getComparisonRowsFromItems = items => {
  const isSingleItem = items.length === 1;
  const {
    header,
    sticky
  } = items.reduce(getHeadersRowsFromItem, {
    header: [],
    sticky: []
  });
  return {
    header: [...header, ...(isSingleItem ? [{
      id: 'header-empty'
    }] : [])],
    sticky: [...sticky, ...(isSingleItem && sticky.length ? [{
      id: 'header-sticky-empty',
      content: ''
    }] : [])],
    rows: items[0]?.specification.reduce(getCommonItemsSpecification(items), []).reduce(getRowsFromSpecification(isSingleItem), []) || []
  };
};
exports.getComparisonRowsFromItems = getComparisonRowsFromItems;
//# sourceMappingURL=utils.js.map